
import { useState } from 'react';
import { seasonalPromos } from '../../../mocks/promoDeals';

export default function SeasonalPromos() {
  const [copiedCode, setCopiedCode] = useState<string | null>(null);

  const handleCopy = (code: string) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(null), 2000);
  };

  return (
    <section id="promo-codes" className="py-24 bg-slate-950">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/20 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-coupon-3-line text-amber-400 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-amber-300 text-sm font-semibold">Promo Codes</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-display mb-4">
            Seasonal Promotions &amp; Codes
          </h2>
          <p className="text-slate-400 max-w-xl mx-auto">
            Copy a code and apply it at checkout for instant savings. Some offers require verification.
          </p>
        </div>

        {/* Promo Cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {seasonalPromos.map((promo) => (
            <div
              key={promo.id}
              className="bg-slate-900 border border-slate-800 rounded-2xl p-6 hover:border-amber-500/30 transition-all group"
            >
              <div className="flex items-start gap-5">
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-amber-500/10 flex items-center justify-center shrink-0">
                  <i className={`${promo.icon} text-2xl text-amber-400`}></i>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <h3 className="text-lg font-bold text-white">{promo.title}</h3>
                    <span className="bg-emerald-500/15 text-emerald-400 text-xs font-bold px-2.5 py-0.5 rounded-full whitespace-nowrap">
                      {promo.discount}% OFF
                    </span>
                  </div>
                  <p className="text-slate-400 text-sm mb-4 leading-relaxed">{promo.description}</p>

                  <div className="flex items-center gap-4 flex-wrap">
                    {/* Code */}
                    <button
                      onClick={() => handleCopy(promo.code)}
                      className="inline-flex items-center gap-2 bg-slate-800 border border-dashed border-slate-600 rounded-lg px-4 py-2 hover:border-amber-500/50 transition-all cursor-pointer group/code"
                    >
                      <code className="text-amber-400 font-mono font-bold text-sm">{promo.code}</code>
                      <i className={`${copiedCode === promo.code ? 'ri-check-line text-emerald-400' : 'ri-file-copy-line text-slate-500 group-hover/code:text-amber-400'} transition-colors w-4 h-4 flex items-center justify-center`}></i>
                    </button>

                    {/* Valid Until */}
                    <span className="text-slate-500 text-xs flex items-center gap-1.5">
                      <i className="ri-calendar-line w-3 h-3 flex items-center justify-center"></i>
                      Valid until {promo.validUntil}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
